export const WEEKLY_SCHEDULING_LABELS = {
	daysToRunScan: 'Days to run scan',
	time: 'Time',
	timezone: 'Timezone'
};
